import {
  createRef,
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from "react";
import { IDialogHandle } from "../types";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  selectTermsOfUseDialogState,
  setTermsOfUseDialogState,
} from "../reducers/general";
import TermsOfUseDialog from "../components/TermsOfUse/TermsOfUseDialog";

interface Props {}

export const TermsOfUseRef = createRef<IDialogHandle>();

const TermsOfUse: ForwardRefRenderFunction<IDialogHandle, Props> = (_, ref) => {
  const isTermsOfUseOpen = useAppSelector(selectTermsOfUseDialogState);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(setTermsOfUseDialogState(true));
  };

  const handleClose = () => {
    dispatch(setTermsOfUseDialogState(false));
  };

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose,
    };
  });

  return <TermsOfUseDialog handleClose={handleClose} open={isTermsOfUseOpen} />;
};

export default forwardRef(TermsOfUse);
